import { useStore } from 'vuex'

export default {
    name: "TheAside",
    setup(props) {
        const store = useStore()

        const openSourceOverlay = (event, source) => {
            store.commit('main/set_page_overlay_content_data', { source: source })
            store.dispatch('main/openPageOverlay', {
                overlayContent: "SourceOverlay",
                returnTarget: event.currentTarget
            })
        }

        return {
            openSourceOverlay
        }
    }
}